import { Button, Grid, Tooltip } from '@material-ui/core';
import { NodeStatus, NodeTypeName, User, UserRole } from '../../domain/domain';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../reducers';
import { ComponentManagementActionType } from '../../reducers/comp.actions';
import PageLeaveConfirmationDialog from './../PageLeaveConfirmationDialog/PageLeaveConfirmationDialog';
import { isMacOs } from 'react-device-detect';

type Props = {
    onCancelClicked: () => void,
    onSaveClicked: () => void,
    changer: () => void,
    contentChanged?: boolean,
    hasActiveChange: boolean,
}

const EditorBottomBar: React.FC<Props> = ({ onSaveClicked, onCancelClicked, changer, contentChanged, hasActiveChange }) => {

    const currentUser: User | undefined = useSelector((app: ApplicationState) => app.user.currentUser);
    const editorNode = useSelector((app: ApplicationState) => app.comp.editorNode);
    const mode = useSelector((app: ApplicationState) => app.comp.editorMode);
    const dispatch = useDispatch();
    const [confirmCancelOpen, setConfirmCancelOpen] = useState(false);
    const saveBtnTooltipText = isMacOs ? <span>&#x2318;+S</span> : "CTRL+S";

    if (!currentUser) {
        return <></>
    }

    let articleEdit = editorNode !== undefined && editorNode.nodeType === NodeTypeName.ARTICLE && currentUser.userRole === UserRole.NON_PUBLICATIONS_TEAM;
    let editable = currentUser.userRole === UserRole.PUBLICATIONS_TEAM || currentUser.userRole === UserRole.ADMINISTRATOR || articleEdit;
    let approvable = currentUser.userRole === UserRole.PUBLICATIONS_TEAM || currentUser.userRole === UserRole.ADMINISTRATOR;

    const onApproveClicked = () => {
        dispatch({ type: ComponentManagementActionType.APPROVE_COMPONENT_DIALOG_OPEN, open: true });
        changer()
    }

    const onRejectClicked = () => {
        dispatch({ type: ComponentManagementActionType.REJECT_COMPONENT_DIALOG_OPEN, open: true });
    }

    const handleCancel = () => {
        if (hasActiveChange) {
            setConfirmCancelOpen(true);
            return;
        }

        setConfirmCancelOpen(false);
        dispatch({ type: ComponentManagementActionType.EDITOR_MODE_UPDATED, editorMode: "view" });
    };

    const handleCancelConfirmation = () => {
        setConfirmCancelOpen(false);
        onCancelClicked();
        dispatch({ type: ComponentManagementActionType.EDITOR_MODE_UPDATED, editorMode: "view" });
    }

    const handleCloseConfirmation = () => {
        setConfirmCancelOpen(false);
    }

    let approveEnabled = editorNode !== undefined && editorNode.status === NodeStatus.CHANGED_NOT_APPROVED && approvable;

    return (
        <>
            <Grid container direction='row' spacing={1} style={{paddingBottom: 8, paddingTop: 8}}>
                {editable && mode === "edit" && (
                    <Grid item>
                        <Button
                            variant='outlined'
                            color='secondary'
                            size='small'
                            onClick={handleCancel}
                        >
                            Close
                        </Button>
                    </Grid>
                )}
                <Grid item>
                    {mode === "edit" && (
                        <Tooltip title={saveBtnTooltipText} enterDelay={0} arrow placement="top">
                            <Button
                                variant='outlined'
                                color='primary'
                                disabled={!contentChanged}
                                size='small'
                                onClick={() => {
                                    onSaveClicked();
                                }}
                            >
                                Save WC
                            </Button>
                        </Tooltip>
                    )}
                    {mode === "view" && currentUser.userRole !== UserRole.NON_PUBLICATIONS_TEAM && (
                        <Button
                            variant='outlined'
                            color='secondary'
                            size='small'
                            disabled={!editable}
                            onClick={
                                () => {
                                    dispatch({ type: ComponentManagementActionType.EDITOR_MODE_UPDATED, editorMode: "edit" });
                                }}
                        >
                            Edit WC
                        </Button>
                    )}
                </Grid>
                {mode !== 'edit' && approvable &&
                        <>
                            { currentUser.userRole !== UserRole.PUBLICATIONS_TEAM &&
                                <Grid item>
                                    <Button
                                        size='small'
                                        variant='outlined'
                                        color='secondary'
                                        onClick={onApproveClicked}
                                        disabled={!approveEnabled}
                                    >
                                        Approve WC changes
                                    </Button>
                                </Grid>
                            }
                            <Grid item>
                                <Button
                                    size='small'
                                    variant='outlined'
                                    color='secondary'
                                    onClick={onRejectClicked}
                                    disabled={!approveEnabled}
                                >
                                    Reject WC changes
                                </Button>
                            </Grid>
                        </>
                }
            </Grid>
            <PageLeaveConfirmationDialog
                open={confirmCancelOpen}
                text={"You have made a change. Are you sure you want to exit without saving your changes? All changes will be lost"}
                onCancel={handleCloseConfirmation}
                onConfirm={handleCancelConfirmation}
            />
        </>
    )
}

export default EditorBottomBar;
